import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography, Button, Avatar } from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { FormattedMessage } from "react-intl";
import { isIE } from "react-device-detect";
import { resetPasswordPageConfig } from "../constants/constants";
import messages from "../constants/messages";
import { styles } from "./../constants/styles";
import { useUserSettings } from "../../../../user/components/UserSettings/useUserSettings";
import { RequestStatus, useAuth } from "../../../shared";
import { PasswordField } from "../../../../../shared";
import { valueType } from "../constants/types";
import { useEffect, useState } from "react";

type Props = WithStyles<typeof styles> & { submit: (a: boolean) => void };

const ChangePasswordPage: React.FC<Props> = (props: Props) => {
  const {
    setValidNewPass,
    changeField,
    validNewPass,
    apply,
    state: stateForm,
    validPass,
    setValidPass,
    resetUserSettings,
    status,
  } = useUserSettings();
  const [disableBtn, setDisableBtn] = useState(true);
  const handleApply = () => {
    if (validPass && validNewPass && stateForm.password !== stateForm.newPassword) {
      apply();
    }
  };

  useEffect(() => {
    if (status === RequestStatus.Success) {
      props.submit(true);
    }
    if (status === RequestStatus.Fail) {
      resetUserSettings();
    }
  }, [status]);
  useEffect(() => {
    const { newPassword, confirmPassword, password } = stateForm;
    if (validPass && validNewPass && newPassword !== password && confirmPassword === newPassword) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [validPass, validNewPass]);
  const handleKeyPress = (event: any) => {
    if (event.key === "Enter" && !disableBtn) {
      handleApply();
    }
  };

  const { classes } = props;
  return (
    <>
      <div className={classes.root} style={status === RequestStatus.Pending ? { opacity: "0.5" } : {}}>
        <Box className={classes.box}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography className={classes.header}>
            <FormattedMessage {...messages.headerExpired} />
          </Typography>
          {resetPasswordPageConfig.map((item) => {
            return (
              <PasswordField
                variant="outlined"
                InputLabelProps={{
                  className: classes.inputLabel,
                  shrink: isIE ? true : undefined,
                }}
                isHaveTooltip={false}
                className={classes.textField}
                value={stateForm[item.id as valueType]}
                onChange={({ target }) => changeField(item.id, target.value)}
                mode={item.id as any}
                onPasswordInvalid={
                  item.id === "confirmPassword"
                    ? () => setValidNewPass(false)
                    : item.id === "password"
                    ? () => setValidPass(false)
                    : () => {}
                }
                onPasswordValid={
                  item.id === "confirmPassword" ? () => setValidNewPass(true) : item.id === "password" ? () => setValidPass(true) : () => {}
                }
                newPassword={(item.id === "confirmPassword" && stateForm["newPassword"]) || undefined}
                confirmPassword={(item.id === "newPassword" && stateForm["confirmPassword"]) || undefined}
                currentPassword={((item.id === "newPassword" || item.id === "confirmPassword") && stateForm["password"]) || undefined}
                customLabel={(item.id === "newPassword" && messages.newPassword) || undefined}
                onKeyPress={handleKeyPress}
                disabled={status === RequestStatus.Pending}
                customErrorState={
                  item.id === "password" && status === RequestStatus.Fail && !stateForm[item.id]
                    ? true
                    : item.id !== "password" && status === RequestStatus.Fail && !stateForm[item.id]
                    ? false
                    : undefined
                }
                customHelperText={
                  item.id === "password" && status === RequestStatus.Fail && !stateForm.password ? (
                    <FormattedMessage {...messages.passwordWrongError} />
                  ) : undefined
                }
              />
            );
          })}
          <Typography className={classes.passwordLengthHint}>
            <FormattedMessage {...messages.passwordLengthHint} />
          </Typography>
          <div className={classes.buttonBase}>
            <Button className={classes.saveButton} variant="contained" color="primary" onClick={handleApply} disabled={disableBtn}>
              <FormattedMessage {...messages.saveButton} />
            </Button>
          </div>
        </Box>
      </div>
    </>
  );
};

export default withStyles(styles)(ChangePasswordPage);
